import Rukocleon1 from '../../Ruko/Ruko Cleon/Ruko Cleon (1).webp'
import Rukocleon2 from '../../Ruko/Ruko Cleon/Ruko Cleon (2).webp'


const Rukocleonimages =[
Rukocleon1,Rukocleon2
]

export default Rukocleonimages;